<template>
    <div class="card-empty-state-challenge-requests">
        <span class="card-empty-state-challenge-requests__art"></span>
        <h2 class="card-empty-state-challenge-requests__heading">{{ textHeading }}</h2>
        <p class="card-empty-state-challenge-requests__desc">{{ textDesc }}</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            textHeading: {
                type: String,
                default: 'Lorem Ipsum'
            },
            textDesc: {
                type: String,
                default: 'Lorem ipsum dolor sit amet.'
            }
        },
    };
</script>

<style scoped src="@/css/components/card-empty-state-challenge-requests.css"></style>